<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :loading="modalLoading"
      :data="queryContactList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button type="error" size="small" @click="contactDelmodal = true">{{
            $t("alarms.common.delete")
          }}</Button>
        </span>
      </template>
    </Table>

    <Modal v-model="contactDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ Name }} ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          v-hasPermission="['alarm_contact:AlarmContactGroup:delete']"
          size="large"
          long
          @click="deleteContact()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
var tableContactConfigurationVue = {};
export default {
  name: "TableContactConfiguration",
  data() {
    return {
      Name: "",
      modalLoading: true,
      contactDelmodal: false,
      isDisable: false,
      columns: [
        {
          title: this.$t("alarm_contact.name"),
          key: "name"
        },
        {
          title: this.$t("alarm_contact.dept"),
          key: "dept"
        },
        {
          title: this.$t("alarm_contact.position"),
          key: "position"
        },
        {
          title: this.$t("alarm_contact.monitorModule"),
          key: "monitorModuleName"
        },
        {
          title: this.$t("alarm_contact.email"),
          key: "email"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      queryContactList: []
    };
  },
  beforeCreate: function() {
    tableContactConfigurationVue = this;
  },
  mounted: function() {
    tableContactConfigurationVue.listContactsInContactGroup();
  },
  methods: {
    // 联系人组列表
    listContactsInContactGroup: function() {
      tableContactConfigurationVue.$api.contact
        .listContactsInContactGroup({
          contactGroupId: this.$route.query.id
        })
        .then(res => {
          this.modalLoading = false;
          this.queryContactList = res.data;
        });
    },
    // 显示所有数据
    showAllUser: function() {
      tableContactConfigurationVue.listContactsInContactGroup();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.Name = this.queryContactList[index].name;
    },
    // 删除
    deleteContact: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      tableContactConfigurationVue.$api.contactGroup
        .deleteByContactIdAndContactGroupId({
          contactGroupId: this.$route.query.id,
          contactId: this.queryContactList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            tableContactConfigurationVue.listContactsInContactGroup();
            this.isDisable = false;
            this.contactDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/alarm_contact/alarm_contact_group/contact_configuration/TableContactConfiguration.vue